if (!customElements.get("cart-trigger")) {
  class CartTrigger extends HTMLElement {
    constructor() {
      super();

      this.cartTrigger = this.querySelector(".cart-trigger");
      this.cartItemCount = this.querySelector(".cart-trigger__item-count");

      document.addEventListener(
        "cartUpdate",
        this._updateCartItemCount.bind(this)
      );
      document.addEventListener(
        "cartAdd",
        this._updateCartItemCount.bind(this)
      );

      this.openCart = new Event(
        "cartOpen",
        { bubbles: true },
        { detail: { cart_open: true } }
      );

      this.cartTrigger.addEventListener(
        "click",
        this._handleCartTrigger.bind(this)
      );
    }

    _updateCartItemCount(e) {
      this.cartItemCount.innerHTML = `${e.detail.item_count}`;
    }

    _handleCartTrigger(e) {
      e.preventDefault();
      document.dispatchEvent(this.openCart);
    }
  }

  customElements.define("cart-trigger", CartTrigger);
}
